// extracted by mini-css-extract-plugin
module.exports = {"container":"TooltipStyles_container__1RMRa","ReactTooltip":"TooltipStyles_ReactTooltip__16re4"};